import React from "react";

const Education = () => {
  return (
    <section
      style={{
        backgroundColor: "#f3f4f6",
        padding: "4rem 1rem",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "1000px",
          margin: "0 auto",
        }}
      >
        <h2
          style={{
            fontSize: "2rem",
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: "3rem",
            color: "#1f2937",
          }}
        >
          Education
        </h2>

        <div
          style={{
            maxWidth: "600px",
            margin: "0 auto",
            backgroundColor: "white",
            borderRadius: "0.5rem",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            overflow: "hidden",
          }}
        >
          <div style={{ padding: "1.5rem" }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#3b82f6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ marginRight: "0.75rem" }}
              >
                <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                <path d="M6 12v5c3 3 9 3 12 0v-5" />
              </svg>
              <h3
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "600",
                  color: "#1f2937",
                }}
              >
                Purdue University - West Lafayette
              </h3>
            </div>
            <p
              style={{
                fontSize: "1.125rem",
                fontWeight: "500",
                color: "#4b5563",
                marginBottom: "0.5rem",
              }}
            >
              Bachelor of Science in Computer Engineering
            </p>
            <div
              style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem", marginBottom: "0.75rem" }}
            >
              <span
                style={{
                  backgroundColor: "#dbeafe",
                  color: "#1e40af",
                  fontSize: "0.875rem",
                  fontWeight: "500",
                  padding: "0.25rem 0.75rem",
                  borderRadius: "9999px",
                }}
              >
                Minor in Mathematics
              </span>
              <span
                style={{
                  backgroundColor: "#d1fae5",
                  color: "#065f46",
                  fontSize: "0.875rem",
                  fontWeight: "500",
                  padding: "0.25rem 0.75rem",
                  borderRadius: "9999px",
                }}
              >
                Concentration in AI/ML
              </span>
            </div>
            <p
              style={{
                fontSize: "0.875rem",
                color: "#6b7280",
              }}
            >
              Expected Graduation: Fall 2025
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
